import React__default, { useMemo } from 'react';
import FALLBACK_LOCALIZED_TEXT from '../../0020413facae1cc36cee0df641535564dcdb09fa6b611238070d8355ba632140.cfe-internal.js';
import createContextUtilities from '../createContextUtilities/3841674170c200f7bdd32cb74e68b517c71ba9e78ccd1beac3d76de81e3e2a5c.cfe-internal.js';

var fallbackLocalizedText = FALLBACK_LOCALIZED_TEXT;

var _createContextUtiliti = createContextUtilities({
  localizedText: {}
}),
    TranslationContextProvider = _createContextUtiliti.Provider,
    useTranslationContext = _createContextUtiliti.useContext;

var TranslationProvider = function TranslationProvider(_ref) {
  var localizedText = _ref.localizedText,
      children = _ref.children;
  var translationContext = useMemo(function () {
    return {
      localizedText: localizedText
    };
  }, [localizedText]);
  return /*#__PURE__*/React__default.createElement(TranslationContextProvider, {
    value: translationContext
  }, children);
};

export { TranslationProvider, fallbackLocalizedText, useTranslationContext };
